import { Grid } from '@material-ui/core';
import DateTimeBar from './DateTimeBar.component';
import { useStyles } from './AccountData.styles';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';

interface AccountDataProps {
  expirationDate?: Date;
  emailConfirmed?: boolean;
  isForcedPasswordChange?: boolean;
  isVisible: boolean;
  userId: string;
  accountCreated: string;
  accountModified: string;
  lastModifierName: string;
  lastModifierSurname: string;
  lastLogin: string;
  lastForcePasswordChange: string;
}

export default function AccountData(props: AccountDataProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Grid container>
        <Grid item xs={6}>
          <div className={classes.leftText}>Status konta</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>{props.emailConfirmed ? 'Konto aktywne' : 'Konto nieaktywne'}</div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Data i godzina utworzenia konta</div>
        </Grid>
        <Grid item xs={6}>
          {props.accountCreated && <DateTimeBar expirationDate={props.accountCreated} />}
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Data ważności konta</div>
        </Grid>
        <Grid item xs={6}>
          {props.expirationDate && (
            <DateTimeBar expirationDate={props.expirationDate ? props.expirationDate.toString() : ''} />
          )}
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Data i godzina ostatniej modyfikacji</div>
        </Grid>
        <Grid item xs={6}>
          {props.accountModified && <DateTimeBar expirationDate={props.accountModified} />}
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Ostatniej modyfikacji dokonał/a</div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.rightText}>
            {props.lastModifierName} {props.lastModifierSurname}
          </div>
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={6}>
          <div className={classes.leftText}>Ostatnie logowanie do aplikacji {t('global:shortNames.system')}</div>
        </Grid>
        <Grid item xs={6}>
          {props.lastLogin && <DateTimeBar expirationDate={props.lastLogin} />}
        </Grid>

        <hr className={classes.line}></hr>

        <Grid item xs={5}>
          <div className={classes.leftText}>Wymuszenie zmiany hasła</div>
        </Grid>
        <Grid item xs={1}>
          {props.isForcedPasswordChange && <CheckIcon className={classes.checkIcon} />}
        </Grid>
        <Grid item xs={6}>
          {props.lastForcePasswordChange && <DateTimeBar expirationDate={props.lastForcePasswordChange} />}
        </Grid>
      </Grid>
    </div>
  );
}
